import { ApiResponse, zps_ea_war } from '../zps';
import axios, { AxiosResponse } from 'axios';

export interface ILanguage {
  langid: number;
  name: string;
  nativeName: string;
  iso639_1: string;
}

export interface ILanguageResponse extends ApiResponse {
  languages: ILanguage[];
}

export const fetchLanguages = (): Promise<AxiosResponse<ILanguageResponse>> => {
  return axios.get<ILanguageResponse>(`${zps_ea_war}/language`);
};
